/**
 * 이전 처방 불러오기 새 창 화면.
 * 처방 검수 상세에서 window.open으로 열고, BroadcastChannel로 상세 화면과 연동한다.
 */
import { useMenuAccess } from '@/layouts/MenuAccessContext';
import { useToast } from '@/shared/utils/toast';
import { useParams } from '@tanstack/react-router';
import React, { useEffect } from 'react';
import { PreviousPrescriptionDrugsPanel } from './PreviousPrescriptionDrugsPanel';
import { usePreviousDrugsWindowClient } from './previousDrugsWindowChannel';

export const PreviousPrescriptionDrugsWindowPage: React.FC = () => {
  const toast = useToast();
  const { canWrite } = useMenuAccess();
  const { prescriptionImageCode: codeParam } = useParams({
    strict: false,
  }) as { prescriptionImageCode?: string };
  const prescriptionImageCode = codeParam ? decodeURIComponent(codeParam) : '';

  const { status, stagedDrugCodes, registeredDrugCodes, sendAdditions } =
    usePreviousDrugsWindowClient(prescriptionImageCode);

  useEffect(() => {
    document.title = `이전 처방 불러오기 - ${prescriptionImageCode}`;
  }, [prescriptionImageCode]);

  // 추가는 상세 화면의 미저장 행으로 들어가므로 상세 화면이 열려 있어야 한다
  const addDisabledReason = !canWrite
    ? '처방 검수 쓰기 권한이 없어 추가할 수 없습니다.'
    : status === 'connecting'
      ? '처방 검수 상세 화면과 연결하는 중입니다.'
      : status === 'closed'
        ? '처방 검수 상세 화면이 닫혀 추가할 수 없습니다. 상세 화면에서 다시 열어 주세요.'
        : null;

  return (
    <PreviousPrescriptionDrugsPanel
      prescriptionImageCode={prescriptionImageCode}
      stagedDrugCodes={stagedDrugCodes}
      registeredDrugCodes={registeredDrugCodes}
      addDisabledReason={addDisabledReason}
      onAdd={(additions) => {
        if (!sendAdditions(additions)) {
          toast.error('처방 검수 상세 화면과 연결이 끊겨 추가하지 못했습니다.');
          return false;
        }
        toast.success(
          `${additions.length}건을 상세 화면에 미저장 행으로 추가했습니다.`,
        );
        return true;
      }}
      onClose={() => window.close()}
    />
  );
};
